import PropTypes from "prop-types";
import { PageLoadingSpinner, SettingsCard, Space } from "top-component-library";
import MenuSettingsCard from "./menu-settings/MenuSettingsCard";
import TechSupportQuestions from "../TechSupportQuestions";

// Legacy ordering: by display_position, then name_for_owner.
const sortMenus = (menus) =>
  [...menus].sort(
    (a, b) =>
      (a.display_position ?? 1000) - (b.display_position ?? 1000) ||
      (a.name_for_owner ?? "").localeCompare(b.name_for_owner ?? "")
  );

const MenuSettingsTab = ({ menus, isLoading, forceAllowOrderAhead, techSupportContact, onSaveMenu }) => {
  if (isLoading) return <PageLoadingSpinner />;

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <TechSupportQuestions contact={techSupportContact}>
        Put your menus on timers so that they only show to guests when you want them to show.
      </TechSupportQuestions>
      <SettingsCard title="Hours menus are visible">
        <div>
          <p>
            This tab provides more precise control of when each menu is displayed, and (optional) when orders can be
            scheduled for delivery.
          </p>
          <p>
            This has effect if Allow Orders is set to &quot;ON&quot; or &quot;BY SCHEDULE&quot; on the TOP by DoorDash
            Terminal. If Allow Orders is &quot;OFF&quot; (or the Terminal is offline) menus will not show.
          </p>
          <p>
            <i>
              Tip: If you&apos;d like guests to place orders while the store is closed, for delivery the next day, you
              should enable &quot;This menu accepts future orders&quot; below. Then set the delivery/pickup times to
              your store hours, and Orderable Windows to 12AM-12AM.
            </i>
          </p>
          <h5>Formatting</h5>
          <p>
            Type 12AM-12AM if open all day.
            <br />
            Type CLOSED if closed all day.
          </p>
          <p>
            <b>Valid examples</b>
            <br />
            9AM - 2PM, 4PM - 2AM
            <br />
            9AM - 2:30AM
            <br />
            8:15AM - 2:15AM
          </p>
        </div>
      </SettingsCard>
      {sortMenus(menus).map((menu) => (
        <MenuSettingsCard
          key={menu.menuId}
          menu={menu}
          allMenus={menus}
          forceAllowOrderAhead={forceAllowOrderAhead}
          onSave={onSaveMenu}
        />
      ))}
    </Space>
  );
};

MenuSettingsTab.propTypes = {
  menus: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool,
  forceAllowOrderAhead: PropTypes.bool,
  techSupportContact: PropTypes.shape({
    phone: PropTypes.string,
    text: PropTypes.string,
    email: PropTypes.string,
  }),
  onSaveMenu: PropTypes.func.isRequired,
};

export default MenuSettingsTab;
